import { Component, OnInit, ViewChild, Inject, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ContactsService } from '../contacts.service';
import { Contact } from '../contact';
import { EDITING_MODE, ADDING_MODE } from 'src/app/utils/constants';
import { Customer } from '../../customers/customers';
import { Observable, empty, Subject, EMPTY } from 'rxjs';
import { map, debounceTime, finalize, switchMap, tap, startWith, filter } from 'rxjs/operators';
import { API, APIDefinition, Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { faEdit, faUserPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { GridDeleteComponent, DeleteDialogData } from '../../utils/grid-delete-component';
import { LoggingService } from '../../utils/logging.service';
import { AuthService } from '../../auth.service';
import { GlobalEmailService } from '../../utils/globalemail.service';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { io } from 'socket.io-client';

export interface ContactDialogData {

  apn_token: string;
  app_id: string;
  customer: number;
  email: string;
  id: number;
  inactivecontact: boolean;
  issubcontractor: boolean;
  message: string;
  name: string;
  note: string;
  notify_through: string;
  password: string;
  phone: string;
  ratercompid:  number;
  registrationid: string;
  security_group: string;
  username: string;
  customer_name: string;
  mode: number;
  loggedIn: string;
  textoptout: boolean;
  text_preferences: any;
}




@Component({
  selector: 'app-edit-contact-dialog',
  templateUrl: 'edit-contact-dialog.html',
})
export class EditContactDialogComponent implements OnInit {
  homeowner: boolean = false;


  readonly EDITING_MODE = EDITING_MODE;
  readonly ADDING_MODE = ADDING_MODE;

  duplicateWarningResults: any[] = [];
  nameSearch$ = new Subject<string>();

  constructor(public dialogRef: MatDialogRef<EditContactDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ContactDialogData,
              private fb: FormBuilder, public contactService: ContactsService, public log: LoggingService, public ges: GlobalEmailService, public messager: MessagerComponent) {}

      contactForm = new FormGroup({
        name: new FormControl(this.data.name || ''),
        phone: new FormControl(this.data.phone || ''),
        email: new FormControl(this.data.email || ''),
        note: new FormControl(this.data.note || ''),
        password: new FormControl(this.data.password || ''),
        inactivecontact: new FormControl(this.data.inactivecontact || false),
        customer: new FormControl(this.data.customer || 0),
        customer_name: new FormControl(this.data.customer_name || ''),
        security_group: new FormControl(this.data.security_group || ''),
        customer_homeowner : new FormControl(''),
      });

      // Text-message preferences live in their own form so the existing
      // contact-edit payload is untouched. Defaults mirror canText():
      // missing key => confirmations/inspection_results/on_our_way ON, marketing OFF.
      prefsForm = new FormGroup({
        confirmations: new FormControl(this.getPref('confirmations', true)),
        inspection_results: new FormControl(this.getPref('inspection_results', true)),
        marketing: new FormControl(this.getPref('marketing', false)),
        on_our_way: new FormControl(this.getPref('on_our_way', true)),
      });

  @ViewChild('custname', { read: false, static: false}) custNameInputRef: ElementRef;
  id = this.data.id;
  mode = this.data.mode;
  customerNameTwo = this.data.customer_name;

  isLoading = false;

  filteredCustomers: Customer[] = [];
  customer$: Observable<Customer[]>;

  displayFunction(customer: Customer){
      if (customer) { return customer.customer_name; }
  }

  // Read a text-preference with the canText() default when the key is absent.
  getPref(key: string, def: boolean): boolean {
    const p = this.data && this.data.text_preferences;
    if (p && Object.prototype.hasOwnProperty.call(p, key)) {
      return p[key] === true;
    }
    return def;
  }

  // Persist the text-message preference toggles (edit mode only).
  saveTextPreferences(): void {
    if (this.mode !== this.EDITING_MODE) { return; }
    this.contactService.updateTextPreferences(this.data.id, {
      confirmations: !!this.prefsForm.value.confirmations,
      inspection_results: !!this.prefsForm.value.inspection_results,
      marketing: !!this.prefsForm.value.marketing,
      on_our_way: !!this.prefsForm.value.on_our_way,
      updated_by: this.data.loggedIn || 'staff'
    }).subscribe(
      () => { this.log.info((this.data.loggedIn || 'User') + ' updated text preferences for ' + (this.data.name || '').trim()); },
      err => { this.log.error('Error updating text preferences: ' + err.toString()); }
    );
  }

  ngOnInit() {

      this.customer$ = this.contactForm.get('customer_name').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
        this.isLoading = true;
      }),
      switchMap(value =>
        value.length > 0 ? this.contactService.getCustomersDropdown(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
          )
      )
    );

    this.nameSearch$
    .pipe(
      debounceTime(800),
      switchMap((name) => {
        if (!name || name.length < 3) {
          this.duplicateWarningResults = [];
          return EMPTY;
        }
        return this.contactService.checkDuplicateContacts(name);
      })
    )
    .subscribe((res: any) => {
      this.duplicateWarningResults = res?.Duplicates ?? [];
    })
  }

  onNameInputChange(event: any) {
    if(this.data.mode == this.ADDING_MODE){
      this.nameSearch$.next(event.target.value);
    }
  }

homeownerToggle() {
  this.homeowner = !this.homeowner;
}



onSelectCustomer(customer: Customer): void {
  this.data.customer = customer.customer_id;
  this.contactForm.get('customer').setValue(customer.customer_id);
  this.data.customer_name = customer.customer_name;
  this.contactForm.get('customer_name').setValue(customer.customer_name);
  this.custNameInputRef.nativeElement.value = customer.customer_name;
}
onNoClick(): void {
        this.dialogRef.close();
      }
      
handleModalResponse(response : boolean) : void {
    const modal = document.getElementById('updatemodal');
    if(modal){
      modal.style.display = 'none';
    }
    
    if(response){
      this.messager.openSnackBar('Saving contact...', '', 'errorAlert');
      this.save(true);
    }else {
      return;
    }

}

showModal() {
  const modal = document.getElementById('updatemodal');
  if(modal){
    modal.style.display = 'block';
  }
}

updateFutureContacts() {

  this.messager.openSnackBar('Updating future jobs...stand by', '', 'errorAlert');
  this.log.info(this.data.loggedIn + 'attempted to update future contacts for ' + this.data.name);
  this.contactService.updateFutureContacts(this.data.id).subscribe(
    res =>{
      if(res.Error){
        this.messager.openSnackBar('Error updating future contacts.', '', 'errorAlert');
      }else {
        this.messager.openSnackBar(res.Message, '', 'successAlert');
      }
    });
}

save(updateFutureContacts: boolean = false) {
  // Persist text-message preferences alongside the contact edit.
  this.saveTextPreferences();
  this.contactService.saveEditedContact(this.data.id, this.contactForm.value).subscribe(
      res => {
        if(updateFutureContacts){
          this.updateFutureContacts();
        }else{
          this.dialogRef.close();
        }

        let changedProperties = [];
        Object.keys(this.contactForm.controls).forEach((name) => {
            const currentControl = this.contactForm.controls[name];
            if (currentControl.dirty) {
              changedProperties.push(name +': ' + this.contactForm.controls[name].value);
            }
          });

        if(res.Error){
          let errMessage = res.Message;
          this.messager.openSnackBar('Error saving contact, an email with all data has been sent to support.', '[close]', 'errorAlert');

          this.ges.sendDebugEmail('IMPORTANT', this.contactForm.value,'Contacts', errMessage).subscribe(
            res => {
              if(res.Error){
                this.log.error('Error sending debug email for contacts page: ' + res.Message)
              }else {
                this.log.debug('Debug email sent to support from the contact page.')
              }
            }, err => {
              this.log.error('Application error sending debug email: ' + err.toString() );
            })

          this.log.error(this.data.loggedIn + ' encountered an error editing a contact: Submitted data: ' + '{' + this.contactForm.value + '} ' + res.Message );
        }else {
          this.log.info(this.data.loggedIn + ' saved the following edits to contact ' + this.data.name.trim() + ' {' + changedProperties.toString() + '}' );
        }
      },
      err => {
        this.log.error(this.data.loggedIn + ' encountered an error editing a contact: Submitted data: ' + '{' + this.contactForm.value.toString() + '} ' + err.toString() );
      }
  );
}



add() {
  if(this.homeowner){

    this.contactService.addHomeowner(
      {
        customer_homeowner: this.contactForm.value.customer_homeowner
      }).subscribe(
        res => {
          this.contactForm.value.customer = res.Customer;
          this.contactForm.value.customer_name = this.contactForm.value.customer_homeowner;
      })

  }


  this.contactService.addContact(this.contactForm.value).subscribe(
    res => {
      this.dialogRef.close();
      if(res.Error){


         let errMessage = res.Message;
          this.messager.openSnackBar('Error adding contact, an email with all data has been sent to support.', '[close]', 'errorAlert');

          this.ges.sendDebugEmail('IMPORTANT', this.contactForm.value,'Contacts', errMessage).subscribe(
            res => {
              if(res.Error){
                this.log.error('Error sending debug email for contacts page: ' + res.Message)
              }else {
                this.log.debug('Debug email sent to support from the contact page.')
              }
            }, err => {
              this.log.error('Application error sending debug email: ' + err.toString() );
            })


        this.log.error(this.data.loggedIn + ' encountered an error adding a contact: Submitted data: ' + '{' + this.contactForm.value.toString() + '} ' + res.Message );
        }else {
          this.log.info(this.data.loggedIn + ' created ' + this.contactForm.value.name.trim() + ' as a contact' );
        }
    },
    err => {
      this.log.error(this.data.loggedIn + ' encountered an error creating a contact: Submitted data: ' + '{' + this.contactForm.value.toString() + '} ' + err.toString() );
    }
  );

}

} // class edit contact


@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['../../../../node_modules/ngx-easy-table/style.css', './contacts.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ContactsComponent implements OnInit {

  // dialog definitions
  apn_token: string;
  app_id: string;
  customer: number;
  email: string;
  id: number;
  inactivecontact: boolean;
  issubcontractor: boolean;
  message: string;
  name: string;
  note: string;
  notify_through: string;
  password: string;
  phone: string;
  ratercompid: number;
  registrationid: string;
  security_group: string;
  username: string;
  customer_name: string;
  socket: any;


  public configuration: Config;
  public columns: Columns[];
  editData;

  faedit = faEdit;
  fatrash = faTrashAlt;
  fauserplus = faUserPlus;

  user;
  usernamee;

  modal = false;
  selected;

  contacts$: Observable<Contact[]>;
  existingContactIds: Set<number> = new Set<number>();

  pagename: string;
  displayedColumns: string[] = ['name', 'email', 'phone'];

  constructor(public contactService: ContactsService, public dialog: MatDialog, public deleteDialog: MatDialog,public auth: AuthService, public log: LoggingService) {

        this.socket = io(this.contactService.getBaseURL());

  }

  openDialog(myData): void {

    this.contactService.getOneContact(myData.id).subscribe(
      (tdata: any) => {

        const dialogRef = this.dialog.open(EditContactDialogComponent, {
          width: '400px',
          data: {
            apn_token: tdata.apn_token,
            app_id: tdata.app_id,
            customer: tdata.customer,
            customer_name: tdata.customer_name,
            email: tdata.email,
            id: tdata.id,
            inactivecontact: tdata.inactivecontact,
            issubcontractor: tdata.issubcontractor,
            message: tdata.message,
            name: tdata.name,
            note: tdata.note,
            notify_through: tdata.notify_through,
            password: tdata.password,
            phone: tdata.phone,
            ratercompid: tdata.ratercompid,
            registrationid: tdata.registrationid,
            security_group: tdata.security_group,
            username: tdata.username,
            textoptout: tdata.textoptout,
            text_preferences: tdata.text_preferences,
            mode: 1,
            loggedIn: this.usernamee || 'User'
          },
          panelClass: 'edit-dialog-container'
        });

        dialogRef.afterClosed().subscribe(result => {
          this.editData = result;
        });

      }
    )




  }


  ngOnDestroy() {
    if (this.socket) {
      this.socket.off('newContact');
    }
  }

  ngOnInit() {

    this.contactService.init();

        this.auth.userProfile$.subscribe(
    (profile) => {

      this.user = profile;
      this.usernamee = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
    });

    this.name = 'Contact Page Test';

    this.configuration = {...DefaultConfig};
    this.configuration.tableLayout.theme = 'lIGHT';
    this.configuration.tableLayout.style = 'big';
    this.configuration.tableLayout.borderless = false;
    this.configuration.tableLayout.hover = true;
    this.configuration.searchEnabled = true;
    this.configuration.paginationEnabled = true;
    this.configuration.paginationRangeEnabled = false;
    this.configuration.isLoading = true;
    this.configuration.rows = 100;

    this.contacts$ = this.contactService.getInitialContacts().pipe(
      tap(contacts => {
        contacts.forEach(c => this.existingContactIds.add(c.id)); 
        this.configuration.isLoading = this.contactService.isLoading;
      })
    );

    this.socket.on('newContact', data => {
      const newContact = data.newOne;
      if (!newContact?.id) return;

      if (this.existingContactIds.has(newContact.id)) {
        return;
      }

      this.existingContactIds.add(newContact.id);
      this.contactService.addOneFrontend(newContact);
    });



    this.columns = [
      { key: '', title: '', searchEnabled: false},
      { key: 'name', title: 'Name' },
      { key: 'phone', title: 'Phone' },
      { key: 'email', title: 'E-mail' },
      { key: 'customer_name', title: 'Customer'}
    ];

  }

  onRowClicked(row): void {
    alert('Their name is ' + row.name);
  }

  getTypeaheadResults(): void {
  }

  onEvent(event: {event: string, value: any}): void {

    if (typeof event.value.row !== 'undefined') {
      const id = event.value.row.id;
      const singleContactHttp$ = this.contactService.getSingleContact(id).subscribe(
          function(data) {
            this.selected = data;
          }
        );
    } else {
      return;
    }
  }

  showModal(): void {
    this.modal = true;
  }

  hideModal(): void {
    this.modal = false;
  }




  addContactDialog(): void {
    const dialogRef = this.dialog.open(EditContactDialogComponent, {
      width: '400px',
      data: {
        mode: 2
      },
      panelClass: 'edit-dialog-container'
    });
  }

  deleteContactDialog(contact): void {
    const dialogRef = this.dialog.open(GridDeleteComponent, {
      width: '500px',
      data: {
        delete_body_text: 'Are you sure you want to delete ' + contact.name + '?',
        delete_api_url: '/rhAPI/contacts/delete/',
        delete_id: contact.id,
        delete_header_text: 'Deleting ' + contact.name
      },
      panelClass: 'edit-dialog-container'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.contactService.deleteContact(contact.id);
        this.log.info(this.usernamee + ' deleted the contact: ' + contact.name + ' id: ' + contact.id);
      }
    });

  }


}
